import { Suspense } from 'react';
import { Link, Outlet } from 'react-router';
import { Card, CardBody } from '../../components';
import { ErrorBoundary } from '../ErrorBoundary';
import { useCurrentRoute, usePageAnnouncements } from '../route-meta';

/**
 * Public layout (legacy layout_login_page_begin): logo, one centred panel, links between the
 * login/signup/password pages. MantisBT has no marketing pages; the public area is the entry flow.
 */
export function PublicLayout() {
  const current = useCurrentRoute();
  usePageAnnouncements(current?.title);
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:start-2 focus:top-2 focus:z-(--z-toast) focus:bg-surface focus:px-3 focus:py-2"
      >
        Skip to main content
      </a>
      <header className="on-dark flex h-navbar items-center bg-navbar px-4">
        <Link
          to="/login"
          className="text-3xl font-light text-ink-inverse no-underline hover:text-ink-inverse hover:no-underline"
        >
          MantisBT
        </Link>
      </header>
      <main
        id="main"
        tabIndex={-1}
        className="flex flex-1 items-start justify-center px-4 py-8 outline-none sm:items-center"
      >
        {/* the panel appears once its page has loaded: a spinner inside a vertically centred card
            would make the whole panel jump when the form replaces it (layout shift) */}
        <Suspense fallback={null}>
          <div className="w-full max-w-md">
            <Card tone="primary">
              <div className="border-b border-sidebar-accent bg-primary px-4 py-2.5 text-ink-inverse">
                <h1 id="page-title" tabIndex={-1} className="text-xl font-light outline-none">
                  {current?.title}
                </h1>
              </div>
              <CardBody>
                <ErrorBoundary>
                  <Outlet />
                </ErrorBoundary>
              </CardBody>
            </Card>
            <nav aria-label="Account" className="mt-4">
              <ul className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-sm [&_a]:text-link-hover">
                <li>
                  <Link to="/login">Log in</Link>
                </li>
                <li>
                  <Link to="/signup">Sign up for a new account</Link>
                </li>
                <li>
                  <Link to="/lost-password">Lost your password?</Link>
                </li>
              </ul>
            </nav>
          </div>
        </Suspense>
      </main>
      <footer className="px-4 pb-4 text-center text-xs text-ink">
        Copyright © 2000–{new Date().getFullYear()} MantisBT Team
      </footer>
    </div>
  );
}
